module.exports = __webpack_public_path__ + "img/logo-m&a2.72f79e57.jpg";